import { Component } from '@angular/core';

@Component({
    selector: 'app-conduct',
    imports: [],
    template: `
        <section>
            <h2>Code of Conduct</h2>
            <h3>Purpose</h3>
            <p>
                A primary goal of our event is to be inclusive to the largest number of
                contributors, with the most varied and diverse backgrounds possible. We are
                committed to providing a friendly, safe, and welcoming environment for all,
                regardless of gender, sexual orientation, ability, ethnicity, socioeconomic status,
                and religion (or lack thereof). We pride ourselves on being an open, respectful, and
                inclusive community. That means jerky behavior isn’t allowed.
            </p>

            <p>
                This goal and policy is applied to any and all events. All attendees are expected to
                comply in full to this policy.
            </p>

            <p>
                This Code of Conduct outlines our expectations for all those who participate in our
                community, as well as the consequences for unacceptable behavior. We invite all
                those who participate in Google Developers Group to help us create safe and positive
                experiences for everyone. We also include ways for DevFest attendees to report any
                violations. Together we can make DevFest KC a fun harassment-free conference
                experience for everyone, regardless of gender, gender identity, sexual orientation,
                disability, physical appearance, body size, race, or religion.
            </p>

            <h3>Open [Source/Culture/Tech] Citizenship</h3>
            <p>
                A supplemental goal of this Code of Conduct is to increase open
                [source/culture/tech] citizenship by encouraging participants to recognize and
                strengthen the relationships between our actions and their effects on our community.
                Communities mirror the societies in which they exist, and positive action is
                essential to counteract the many forms of inequality and abuses of power that exist
                in society. If you see someone who is making an extra effort to ensure our community
                is welcoming, friendly, and encourages all participants to contribute to the fullest
                extent, we want to know.
            </p>

            <h3>Expected Behavior</h3>
            <p>The following behaviors are expected and requested of all community members:</p>

            <ul>
                <li>
                    Participate in an authentic and active way. In doing so, you contribute to the
                    health and longevity of this community.
                </li>
                <li>Exercise consideration and respect in your speech and actions.</li>
                <li>Attempt collaboration before a conflict.</li>
                <li>Refrain from demeaning, discriminatory, or harassing behavior and speech.</li>
            </ul>

            <p>
                Be mindful of your surroundings and your fellow participants. Alert community
                leaders if you notice a dangerous situation, someone in distress, or violations of
                this Code of Conduct, even if they seem inconsequential.
            </p>

            <h3>Unacceptable Behavior</h3>
            <p>
                The following actions are considered harassment and are unacceptable within our
                community:
            </p>

            <ul>
                <li>
                    Violence, threats of violence or violent language directed against another
                    person.
                </li>
                <li>
                    Sexist, racist, homophobic, transphobic, ableist or otherwise discriminatory
                    jokes and language.
                </li>
                <li>Posting or displaying sexually explicit or violent material.</li>
                <li>
                    Posting or threatening to post other people’s personally identifying information
                    ("doxing").
                </li>
                <li>
                    Personal insults, particularly those related to gender, sexual orientation,
                    race, religion, or disability.
                </li>
                <li>Inappropriate photography or recording.</li>
                <li>
                    Inappropriate physical contact. You should have someone’s consent before
                    touching them.
                </li>
                <li>
                    Unwelcome sexual attention. This includes sexualized comments or jokes;
                    inappropriate touching, groping, and unwelcome sexual advances.
                </li>
                <li>Deliberate intimidation, stalking or following (online or in person).</li>
                <li>Advocating for, or encouraging, any of the above behavior.</li>
                <li>
                    Sustained disruption of community events, including talks and, presentations.
                </li>
            </ul>

            <h3>Consequences of Unacceptable Behavior</h3>
            <p>
                Unacceptable behavior from any community member, including sponsors and those with
                decision-making authority, will not be tolerated.
            </p>

            <p>
                Anyone asked to stop unacceptable behavior is expected to comply immediately. If a
                community member engages in unacceptable behavior, DevFest KC organizers may take
                any action they deem appropriate, up to and including a warning, temporary ban, or
                permanent expulsion from the community/event without warning (and without refund in
                the case of a paid event).
            </p>

            <h3>Reporting</h3>
            <p>
                If someone makes you or anyone else feel unsafe or unwelcome, please report it as
                soon as possible. Conference staff can be identified by special lanyards and/or
                special badges. Conference staff is also located at the registration desk throughout
                the duration of the event. Harassment and other code of conduct violations reduce
                the value of our event for everyone. We want you to be happy at our event. People
                like you make our event a better place.
            </p>

            <p>
                You can make a personal report by getting in contact with any of the event
                organizers. Event Organizers can be identified by special lanyards and/or special
                badges. If you wish, you can also use the anonymous form but provide your contact
                information at the end. In the event organizers are not able to be reached, please
                reach out to us directly by phone/email at:
            </p>

            <p>
                Organizer Email: events@gdgtc.org<br />
                Event Organizers: Stephen Fluin, Jeff Williams, Lloyd Lentz, Baskin Tapkan, Sophie
                Le<br />
            </p>
            <p>
                When taking a personal report, our staff will ensure you are safe and cannot be
                overheard. They may involve other event staff to ensure your report is managed
                properly. Once safe, we'll ask you to tell us about what happened. This can be
                upsetting, but we'll handle it as respectfully as possible, and you can bring
                someone to support you. You won't be asked to confront anyone, and we won't tell
                anyone who you are. Our team will be happy to help you contact hotel/venue security,
                local law enforcement, local support services, provide escorts, or otherwise assist
                you to feel safe for the duration of the event. We value your attendance.
            </p>

            <h3>Scope</h3>
            <p>
                We expect all community participants to abide by this Code of Conduct in all
                community venues – online and in-person – as well as in all one-on-one
                communications about community business. This code of conduct and its related
                procedures also applies to unacceptable behavior occurring outside the scope of
                community activities when such behavior has the potential to affect the safety and
                well-being of community members adversely.
            </p>
        </section>
    `,
    styles: ``,
})
export class ConductComponent {}
